export default __webpack_public_path__ + "static/media/Montserrat-Bold.50f0257a.ttf";